import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_API_KEY;
const MIXPANEL_HOST = process.env.NEXT_PUBLIC_MIXPANEL_API_HOST;

let isInitialized = false;

/**
 * Initialize Mixpanel with the configured token and options.
 * Safe to call multiple times - only initializes once.
 */
export function initMixpanel(optedOut: boolean = false): void {
  if (typeof window === "undefined" || isInitialized || !MIXPANEL_TOKEN) {
    return;
  }

  mixpanel.init(MIXPANEL_TOKEN, {
    debug: false, // Suppress console errors from ad blockers
    track_pageview: !optedOut,
    persistence: "localStorage",
    api_host: MIXPANEL_HOST || "https://api-eu.mixpanel.com",
    opt_out_tracking_by_default: optedOut,
  });

  isInitialized = true;
}

/**
 * Set the tracking opt-out state.
 * When opted out, Mixpanel stops collecting data.
 */
export function setTrackingOptOut(optOut: boolean): void {
  if (typeof window === "undefined" || !isInitialized) {
    return;
  }

  if (optOut) {
    mixpanel.opt_out_tracking();
  } else {
    mixpanel.opt_in_tracking();
  }
}

/**
 * Check if Mixpanel has been initialized.
 */
export function isMixpanelInitialized(): boolean {
  return isInitialized;
}

export { mixpanel };
